import { AppUserSettingService } from '@aca-new/app/shared/services/user-services/app-user-setting/app-user-setting.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class InteractiveReportGuard implements CanActivate {
  public constructor(
    private readonly _appUserSettingService: AppUserSettingService,
    private readonly _router: Router
  ) {}

  public canActivate(_activatedRoute: ActivatedRouteSnapshot, _routerState: RouterStateSnapshot): Observable<boolean> | boolean {
    if (this._appUserSettingService.getInteractiveReportEnabled()) {
      return true;
    }

    void this._router.navigate(['/reports']);

    return false;
  }
}
